import { useQuery } from '@tanstack/react-query';

import { isGenericResponse } from 'api/api-util/api-response';
import { QuestionnairesApi } from 'api/QuestionnairesApi';
import { keepPreviousDataForKey } from 'tanstack-hooks/util/query.util';
import { BANK_QUESTIONNAIRE_KEY } from '../../keys';
import { useUser } from '../../user';

export function useBankQuestionnaire(questionnaireId: string, version = 'latest', enabled = true) {
  const questionnairesApi = new QuestionnairesApi();
  const { userBankId } = useUser();

  const { data: questionnaire, isLoading: isLoadingBankQuestionnaire } = useQuery({
    enabled: enabled && !!userBankId.length && !!questionnaireId.length,
    queryKey: [BANK_QUESTIONNAIRE_KEY, userBankId, questionnaireId, version],
    // Holds the last render while the page swaps versions as drafts come and go, but never across
    // questionnaires — a different template's data would render as this one's.
    placeholderData: keepPreviousDataForKey([BANK_QUESTIONNAIRE_KEY, userBankId, questionnaireId]),
    queryFn: async () => {
      const response = await questionnairesApi.getQuestionnaire(userBankId, questionnaireId, version);

      // A version the template doesn't have answers with the bare envelope, and react-query won't
      // cache undefined.
      return isGenericResponse(response) ? null : response || null;
    }
  });

  return { questionnaire: questionnaire ?? undefined, isLoadingBankQuestionnaire };
}
